import {Injectable, signal, Signal} from '@angular/core';
import {TrajetDto} from '../../../../shared/dto/trajet.dto';
import {isNullOrUndefined} from '@sigale-angular/src/utils/functions';

/**
 * Service permettant de gérer le trajet actuellement sélectionné dans l'application.
 */
@Injectable({
	providedIn: 'root'
})
export class TrajetSelectionneService {

	/**
	 * Signal représentant le trajet actuellement sélectionné. Null si aucun trajet n'est sélectionné.
	 * Une comparaison par valeur est utilisée pour éviter de déclencher les effets/computed qui en dépendent
	 * lorsque le trajet reçu est une nouvelle instance mais contient les mêmes données (ex : rafraîchissement périodique).
	 */
	private readonly _trajetSelectionne = signal<TrajetDto | null>(null);
	readonly trajetSelectionne: Signal<TrajetDto | null> = this._trajetSelectionne.asReadonly();

	constructor() {
	}

	/**
	 * Enregistre le trajet sélectionné par l'utilisateur dans le signal `trajetSelectionne`.
	 *
	 * @param trajet le trajet à enregistrer.
	 */
	enregistrerTrajetSelectionne(trajet: TrajetDto): void {
		this._trajetSelectionne.set(trajet);
	}

	/**
	 * Actualise le trajet sélectionné depuis une liste de trajets.
	 *
	 * @param trajets le tableau actualisé de trajets.
	 */
	actualiserTrajetSelectionne(trajets: TrajetDto[]): void {
		const trajetSelectionne = this.trajetSelectionne();

		if (isNullOrUndefined(trajetSelectionne?.id)) {
			return;
		}

		const trajetTrouve = trajets.find(trajet => trajet.id === trajetSelectionne.id);

		trajetTrouve
			? this.enregistrerTrajetSelectionne(trajetTrouve)
			: this.deselectionnerTrajet();
	}

	/**
	 * Désélectionne le trajet sélectionné.
	 */
	deselectionnerTrajet(): void {
		this._trajetSelectionne.set(null);
	}
}
